<template>
  <Modal id="PlanDetail" width="60%" :visible="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('plan.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
      <DescriptionsItem :label="$t('plan.field.id_pla')">{{data.idPla}}</DescriptionsItem>
      <DescriptionsItem :label="$t('plan.field.id_ser_pro')">{{data.serviceProviderCompanyName}}</DescriptionsItem>
      <DescriptionsItem :label="$t('plan.field.id_pla_cat')">{{data.planCategoryCategoryName}}</DescriptionsItem>
      <DescriptionsItem :label="$t('plan.field.id_ins_com')">{{data.insuranceCompanyCompanyName}}</DescriptionsItem>
      <DescriptionsItem :label="$t('plan.field.plan_name_hk')">{{data.planNameHk}}</DescriptionsItem>
      <DescriptionsItem :label="$t('plan.field.plan_name')">{{data.planName}}</DescriptionsItem>
      <DescriptionsItem :label="$t('plan.field.plan_code')">{{data.planCode}}</DescriptionsItem>
      <DescriptionsItem :label="$t('plan.field.create_date')">{{data.createDate}}</DescriptionsItem>
      <DescriptionsItem :label="$t('plan.field.status')">{{selectList.statusList.find(item=>item.value===data.status).label}}</DescriptionsItem>
      <DescriptionsItem :label="$t('plan.field.adjust_afyp_rate')">{{data.adjustAfypRate}}</DescriptionsItem>
      <DescriptionsItem :label="$t('plan.field.expiry_date')">{{data.expiryDate}}</DescriptionsItem>
  </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "PlanDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      selectList:{
        statusList: [{value: 0,label: 'Off'},{value:1,label: 'On'}],
      },
      data: {
      },
      visible: false,
    };
  },
  computed: {
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
}
</script>

<style lang="less">
</style>